import React from 'react';
import { ArchLines } from './ArchLines';
type Tome = {
  number: string;
  title: string;
  plans: string;
  promise: string;
  band: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'Opening the Door',
  plans: 'VP-01–VP-14',
  promise: 'Taster and starter classes that help first-timers become a weekly group.',
  band: 'bg-forest',
  contents: ['Taster and drop-in classes for “I can’t dance” newcomers and mixed rooms', 'The first 10 meetings of a new group, week by week', 'The Newcomer Ladder: alone, circle, pairs, small groups', 'Your words for the first class: welcome, agreements and the opt-out line', 'Why newcomers don’t come back — and what brings them back the second week']
}, {
  number: '02',
  title: 'Vitality & Play',
  plans: 'VP-15–VP-28',
  promise: 'Weekly classes that wake up energy, rhythm and joy.',
  band: 'bg-ember-deep',
  contents: ['Shared pulse, body percussion and rhythm-and-pause classes', 'Play for adults, without anyone feeling silly', 'The Energy Dial: set the intensity of the rise from 1 to 5', 'The Peak-and-Landing Rule: every high gets a soft landing', 'Second Wind: bring a flat, low-attendance group back to life']
}, {
  number: '03',
  title: 'Connection & Care',
  plans: 'VP-29–VP-42',
  promise: 'Encounter, trust and tenderness, with consent built in.',
  band: 'bg-moss-deep',
  contents: ['The Contact Consent Ladder: eyes, hands, shoulders, embrace — always opt-in', 'A full connection class with no touch at all', 'The Pair Rotation Pattern: change partners without leaving anyone out', 'Circle classes, and welcoming new members into an established group', 'When emotion rises: stay with it, pause the group, know when to suggest support']
}, {
  number: '04',
  title: 'Creativity & Expression',
  plans: 'VP-43–VP-56',
  promise: 'Classes that free movement, voice and imagination.',
  band: 'bg-patrol-plum',
  contents: ['The Echo-Lead-Free Sequence: copy, then lead, then improvise', 'Movement qualities: soft, sharp, smooth and slow', 'Voice, color and short stories as movement prompts', 'Signature dance and taking up space', 'Thirty one-line movement prompts, sorted by quality']
}, {
  number: '05',
  title: 'Presence & Nature',
  plans: 'VP-57–VP-70',
  promise: 'Classes that slow a group down, follow the seasons and go outdoors.',
  band: 'bg-patrol-teal',
  contents: ['The Stillness Gradient: from slow movement to full stillness and back', 'The Four-Element Wheel: fire, water, air and earth as movement', 'Spring, harvest, winter and long-summer-days classes', 'Park, beach and forest-edge classes, with an outdoor checklist', 'A seasonal theme calendar, one theme per month']
}, {
  number: '06',
  title: 'Workshops, Retreats & Festivals',
  plans: 'VP-71–VP-84',
  promise: 'Ready programs for workshops, weekend retreats and festival slots.',
  band: 'bg-bark',
  contents: ['Half-day (3 h) and full-day (6 h) workshops, fully timed', 'A weekend retreat, from Friday arrival to Sunday goodbye', 'The Festival Slot Formula: 60 minutes for a crowd of strangers', 'A sunset circle and a community celebration for mixed-age adults', 'Run sheets and an event logistics checklist']
}];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="topo-light w-full bg-paper" data-id="element-275" data-mp="iszlb264u4od">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20" data-id="element-276" data-mp="mve0ncalemaw">
        <div className="text-center" data-id="element-277" data-mp="rnnlidwuow6b">
          <p className="eyebrow text-ember-deep" data-id="element-278" data-mp="rop0gtgzm2tb">A year in the life of a group</p>
          <h2 id="tomes-heading" className="trail-underline mt-3 font-display text-[30px] leading-tight text-pine sm:text-5xl" data-id="element-279" data-mp="3radut274qr16">
            Inside the pack — six volumes
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-pine-soft" data-id="element-280" data-mp="3c5rjehk9f3a0">
            Fourteen plans per volume, following a group through the year:
            opening the door, energy, connection, expression and presence —
            then the long formats. Use them in order, or open whatever your
            group needs this week.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-281" data-mp="3uxc1uqqohv9p">
          {tomes.map(tome => <article key={tome.number} className="flex flex-col overflow-hidden rounded-2xl border border-paper-dark bg-white shadow-card" data-id="element-282" data-mp="3pyh7qsn9gkaa">
              <div className={`relative overflow-hidden ${tome.band}`} data-id="element-283" data-mp="3rsm9cljxbux">
                <ArchLines className="pointer-events-none absolute -right-6 -top-8 h-28 w-28 text-white/20" data-id="element-284" data-mp="2ai8m2t9sc9l8" />
                <div className="relative flex items-center justify-between px-5 py-3.5" data-id="element-285" data-mp="25jyqihk5f6z3">
                  <span className="text-[11px] font-bold uppercase tracking-[2px] text-white/90" data-id="element-286" data-mp="l1mw6ytakp5j">
                    Volume {tome.number} · {tome.plans}
                  </span>
                  <span className="font-display text-3xl leading-none text-white" data-id="element-287" data-mp="q2ai562nyfsw">
                    {tome.number}
                  </span>
                </div>
              </div>

              <div className="trail-card flex flex-1 flex-col p-6 pt-5" data-id="element-288" data-mp="g8tmrxmvosn4">
                <h3 className="font-display text-xl leading-snug text-pine" data-id="element-289" data-mp="2a3t6rz9pb3i">
                  {tome.title}
                </h3>
                <p className="mt-1.5 text-sm text-pine-soft" data-id="element-290" data-mp="6adwfwvodneo">{tome.promise}</p>
                <ul className="mt-4 grid gap-2 border-t border-paper-dark pt-4" data-id="element-291" data-mp="3ojo7xj1vqk0z">
                  {tome.contents.map(item => <li key={item} className="flex gap-2.5 text-[14px] leading-snug text-pine" data-id="element-292" data-mp="3tj14ivijz5gr">
                      <span className="mt-[6px] h-2 w-2 flex-none rounded-full bg-ember" data-id="element-293" data-mp="1moxf2qrzw5h0" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}